module.exports = __webpack_public_path__ + "static/media/check-circle-success.ed5849d5.svg";